export default "__VITE_ASSET__z4dz8OXI__"